import React from "react";
import "./ConseillerApp.scss";

export function ConseillerApp() {
  return <div className="Conseiller"></div>;
}
